import { defineMessages } from 'react-intl';

export const messages: {
	selectedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multiAddToFavorites: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multiRemoveFromFavorites: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multiDelete: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearSelection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multiDeleteConfirmTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multiDeleteConfirmBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	delete: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multiShare: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkCopied: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	selectedLabel: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.selected-label',
		defaultMessage: 'selected',
		description: 'Label shown next to the selected count badge in the multiselect toolbar',
	},
	multiAddToFavorites: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.multi-add-to-favorites',
		defaultMessage: 'Add to favorites',
		description: 'Toolbar action to add selected prompts to favorites',
	},
	multiRemoveFromFavorites: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.multi-remove-from-favorites',
		defaultMessage: 'Remove from favorites',
		description: 'Toolbar action to remove selected prompts from favorites',
	},
	multiDelete: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.multi-delete',
		defaultMessage: 'Delete',
		description: 'Toolbar action to delete selected prompts',
	},
	clearSelection: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.clear-selection',
		defaultMessage: 'Clear selection',
		description: 'Toolbar action to clear the current selection',
	},
	multiDeleteConfirmTitle: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.multi-delete-confirm-title',
		defaultMessage: 'Delete {count, plural, one {# prompt} other {# prompts}}?',
		description: 'Title for the multi-delete confirmation modal',
	},
	multiDeleteConfirmBody: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.multi-delete-confirm-body',
		defaultMessage:
			'Are you sure you want to delete {count, plural, one {# prompt} other {# prompts}}? This action cannot be undone.',
		description: 'Body for the multi-delete confirmation modal',
	},
	cancel: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button in the delete confirmation modal',
	},
	delete: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.delete',
		defaultMessage: 'Delete',
		description: 'Delete button in the confirmation modal',
	},
	multiShare: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.multi-share',
		defaultMessage: 'Create link to share',
		description: 'Toolbar action to share selected prompts',
	},
	linkCopied: {
		id: 'rovo-conversation-actions.prompt-library-toolbar.link-copied',
		defaultMessage: 'Link copied!',
		description: 'Success message shown after share link is copied',
	},
});
